// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"139":"component---node-modules-smooth-doc-src-templates-doc-js","216":"component---node-modules-smooth-doc-src-templates-page-js"}[chunkId] || chunkId) + "-" + {"139":"08ecb7913fa6f56038ae","158":"29d764f0ca52b56ca579","216":"4e29f17405cbbe295589"}[chunkId] + ".js";
};